import { ReactComponent as BackIcon } from "app/assets/icons/arrow-left.svg";


interface Props {
    onClick?: () => void;
    className?: string;
}

export default function BackButton({ onClick, className }: Props) {
    return (
        <button aria-label="Go back" type="button" onClick={onClick} tw="flex p-[8px] items-center justify-center bg-containment-tertiary rounded-full" className={className}>
            <BackIcon
                tw="w-[24px] h-[24px]"
                color="#0D0D0D"
            />
        </button>
    );
}